module.exports = function() {
  return new Worker(__webpack_public_path__ + "58a1fdc463ef26b9bfbe.worker.js");
};